import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Product } from '@spartacus/core';
import { CurrentProductService, ProductDetailOutlets } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-uig-product-summary',
    templateUrl: './uig-product-summary.component.html',
    styleUrls: ['./uig-product-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UigProductSummaryComponent implements OnInit {
  outlets = ProductDetailOutlets;

  product$: Observable<Product> = this.currentProductService.getProduct();
  
  constructor(private currentProductService: CurrentProductService) { }

  ngOnInit(): void {
  }

}
